import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { createSelector } from 'reselect'

import { CockpitUserType } from '../../api/types'

import { selectCockpitOffering } from './selectCockpitOffering'
import { selectCockpitPendingActionsUsers } from './selectCockpitPendingActionsUsers'

/** The partner's own users in the offering in view; `Overall` and `Consolidated` read them all. */
export const selectCockpitPartnerUsers = createSelector(
  [selectCockpitPendingActionsUsers, selectCockpitOffering],
  (users, selectedOffering) =>
    users.filter(
      (user) =>
        user.UserType === CockpitUserType.Partner &&
        (selectedOffering === ProgramTypes.Overall ||
          selectedOffering === ProgramTypes.Consolidated ||
          user.Offering === selectedOffering)
    )
)
